import styled from "styled-components";
import { Link } from "react-router-dom";

export const StyledLink = styled(Link)`
  height: 100%;

  padding: 1.5rem;
  text-decoration: none;
  font-size: 16px;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  color: black;
  background: #F8F7F5;
  border: 1px solid black;
  border-radius: 0.5rem;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  /* same hover motion as the Home "How do I" tiles */
  transition: transform .6s ease, background .6s ease;

  h3 {
    font-size: 20px;
  }
  p,
  h3 {
    transition: color .6s ease;
  }
  .caret svg path {
    stroke: black;
    transition: stroke .6s ease;
  }

  &:hover {
    transform: scale(1.025);
    * p,
    * h3 {
      color: white;
    }
    background: black;

    .step-description {
      visibility: visible;
    }
  }

  .step-description {
    visibility: hidden;
  }

  &.disabled {
    /* pointer-events: none; */
    cursor: default;
  }
`;

export const StyledExternalLink = styled.a`
  height: 100%;

  padding: 1.5rem;
  text-decoration: none;
  font-size: 16px;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  color: black;
  background: #F8F7F5;
  border: 1px solid black;
  border-radius: 0.5rem;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  /* same hover motion as the Home "How do I" tiles */
  transition: transform .6s ease, background .6s ease;

  h3 {
    font-size: 20px;
  }
  p,
  h3 {
    transition: color .6s ease;
  }
  .caret svg path {
    stroke: black;
    transition: stroke .6s ease;
  }

  &:hover {
    transform: scale(1.025);
    * p,
    * h3 {
      color: white;
    }
    background: black;

    .step-description {
      visibility: visible;
    }
  }

  .step-description {
    visibility: hidden;
  }
`;

export const StyledStep = styled.div`
  height: 100%;

  padding: 1.5rem;
  text-decoration: none;

  overflow: hidden;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  color: black;
  background: #F8F7F5;
  border: 1px solid black;
  border-radius: 0.5rem;
  transform: translateZ(0);
  -webkit-font-smoothing: subpixel-antialiased;
  /* same hover motion as the Home "How do I" tiles */
  transition: transform .6s ease, background .6s ease;

  h3 {
    font-size: 20px;
  }
  p,
  h3 {
    transition: color .6s ease;
  }
  .caret svg path {
    stroke: black;
    transition: stroke .6s ease;
  }

  &:hover {
    transform: scale(1.025);
    * p,
    * h3 {
      color: white;
    }
    background: black;

    .step-description {
      visibility: visible;
    }
  }

  .step-description {
    visibility: hidden;
  }
`;
